var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.enableAppBar)?_c('v-app-bar',{attrs:{"app":"","elevation":"0","color":"white"}},[_c('v-app-bar-nav-icon',{on:{"click":_vm.toggleNavDrawer}}),_c('v-spacer'),_c('v-app-bar-title',[_vm._v(_vm._s(_vm.appBarTitle))]),_c('v-spacer')],1):_vm._e(),(_vm.enableNavDrawer)?_c('navigation-drawer'):_vm._e(),_c('v-main',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }